import React from 'react';
import { Route } from 'react-router-dom';
import {
  clientRouterHubLocales,
  LOCALE_ROUTE_PREFIX,
} from '../config/localeRoutes';
import LocalePrefixedHome from './LocalePrefixedHome';

export function localizedLocaleHubRouteElements(): React.ReactNode[] {
  return clientRouterHubLocales().flatMap((locale) => {
    const prefix = LOCALE_ROUTE_PREFIX[locale];
    if (!prefix) return [];
    return [
      <Route key={`${locale}-hub`} path={prefix} element={<LocalePrefixedHome />} />,
      <Route key={`${locale}-hub-trailing`} path={`${prefix}/`} element={<LocalePrefixedHome />} />,
    ];
  });
}
